const inputValidator = (value, validator, required=true, force=false, pristine=false) => {
    if (pristine && !force) {
        return {isValid: true, message: ""}
    }
    if (!required && !value) {
        return {isValid: true, message: ""}
    }
    return validator(value)
}
export default inputValidator